import api from "../../services/api";


export default async function confirmCodTipica(idmsg) {
	
	const { data } = await  api.get(`MensajesC/gettipificod/${idmsg}`);
	return  data;
}

